//
// FeatureFlagStrategy.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/TransportModel";
import "./FeatureFlagParam";

var FeatureFlagStrategy = createModule("transport::FeatureFlagStrategy", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        id: 7,
        parameters: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default FeatureFlagStrategy;
